export enum OrderTypes
{
    TAKEIN = 1,
    TAKEOUT = 2
}